<template>
  <div id="app">
    <div class="container">
        <div class="text-area">
            <div class="center">
                <img class="main-logo" src="./assets/main_logo.png" />
                <span class="text1">소비자만족지수 1위</span>
                <span class="text2">솔닥 비대면진료</span>
                <span class="text3">2024 한국소비자만족지수 비대면진료 1위 &lt;한경비즈니스 주최&gt;</span>
                <img class="qr-image" src="./assets/qr.png" />
            </div>
        </div>
        <div class="mobile-area">
          <router-view class="mobile"></router-view>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Pretendard';
  
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  
}

.v-application {
  font-family: 'Pretendard', sans-serif !important;
}

@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Thin.ttf') format('truetype');
  font-weight: 100;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraLight.ttf') format('truetype');
  font-weight: 200;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Light.ttf') format('truetype');
  font-weight: 300;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Regular.ttf') format('truetype');
  font-weight: 400;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Medium.ttf') format('truetype');
  font-weight: 500;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-SemiBold.ttf') format('truetype');
  font-weight: 600;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Bold.ttf') format('truetype');
  font-weight: 700;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraBold.ttf') format('truetype');
  font-weight: 800;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Black.ttf') format('truetype');
  font-weight: 900;
}
</style>

<style scoped>
/* 기본 스타일 */

.main-logo {
    width: 130px;
}

.qr-image {
    width: 145px;
    margin-top: 30px;
    cursor: pointer;
}

.text1{
    margin-top: 29px;
    color: #1A1A1A;
    font-family: Pretendard;
    font-size: 46px;
    font-style: normal;
    font-weight: 600;
    line-height: 60px; /* 130.435% */
}

.text2 {
    color: #008DEF;
    font-family: Pretendard;
    font-size: 46px;
    font-style: normal;
    font-weight: 600;
    line-height: 60px; /* 130.435% */
}
.text3 {
    color: #666;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    margin-top: 10px;
}

.container {
    display: flex;
    flex-direction: row; /* 가로 방향으로 항목 정렬 */
    justify-content: center; /* 가운데 정렬 */
    align-items: center;
    background: #E5F0FC;
}

.mobile-area {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
}

.text-area {
    display: none; /* 기본적으로 텍스트 영역 숨김 */
}

.center {
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    width: 480px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.mobile {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* 화면 너비가 960px 초과일 때의 스타일 */
@media (min-width: 960px) {
    .container {
        display: flex;
        flex-direction: row; /* 가로 방향으로 항목 정렬 */
        justify-content: center; /* 가운데 정렬 */
        align-items: flex-start;
        background: #E5F0FC;
    }

    .text-area {
        display: flex; /* 텍스트 영역 보임 */
        max-width: 480px; /* 최대 너비 설정 */
        width: 480px; /* 너비 고정 */
        position: relative;
        height: 100vh;
    }

    .mobile-area {
        display: flex; /* 모바일 영역 보임 */
        width: 480px; /* 너비 고정 */
        max-width: 480px; /* 최대 너비 설정 */
        justify-content: flex-end;
    }
    .mobile {
        display: flex; /* 모바일 영역 보임 */
        width: 375px; /* 너비 고정 */
        max-width: 375px; /* 최대 너비 설정 */
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue